// Components==============
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { ButtonColor } from 'typings';
import CircleButton from '../CircleButton/CircleButton';
import TooltipMenu from '../Tooltip/TooltipMenu';
import './DotsMenu.module.scss';
// =========================

type Props = {
  children: React.ReactNode;
  type?: ButtonColor;
};

export default function DotsMenu({ type = 'grey-blue', children }: Props) {
  return (
    <TooltipMenu content={<div>{children}</div>} position="bottom-right">
      <CircleButton color={type} onClick={() => {}} icon={faEllipsisH} />
    </TooltipMenu>
  );
}
